
import {owayoUtils} from "./owayoUtils";
import type {Logo, SelectableObject, StockLogo, TextObject} from "./selectableObjects";
import {HTMLPrinter} from "../global/htmlprinter";
import {AbstractSliderWrapper} from "./sliderwrapper";
import {EventVerteiler} from "../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../global/GlobalEventnames";
import {SelObTypes} from "./SelObTypes";

abstract class EntwurfSelObListe extends AbstractSliderWrapper{

    protected static readonly SHOW_SELOB_CLASS = "rotate-to-target";
    protected static readonly DELETE_SELOB_CLASS = "deleteSelOb";
    protected static readonly SELECT_SELOB_CLASS = "selectSelOb";
    protected static readonly selobID_dataProp = id=>HTMLPrinter.dataProp("selobid")(id);



    protected initUebersichtListEventHandlers() {
        const getSelObId = DOMElement=>$(DOMElement).data("selobid");
        const p = HTMLPrinter;

        this.sliderContainer.find(p.classSelector(EntwurfSelObListe.SHOW_SELOB_CLASS))
            .off()
            .click( function(event){EventVerteiler.broadcast(SELOBEVENTNAMES.DISPLAY_SELOB_IN_VIEWER, getSelObId(event.currentTarget))})
            .dblclick(function(event){EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, getSelObId(event.currentTarget))});
        this.sliderContainer.find(p.classSelector(EntwurfSelObListe.DELETE_SELOB_CLASS))
            .off()
            .click(function(event){EventVerteiler.broadcast(SELOBEVENTNAMES.DELETEREQUEST, getSelObId(event.currentTarget))});

        this.sliderContainer.find(p.classSelector(EntwurfSelObListe.SELECT_SELOB_CLASS))
            .off()
            .click(function (event) {
                EventVerteiler.broadcast(SELOBEVENTNAMES.DISPLAY_SELOB_IN_VIEWER, getSelObId(event.currentTarget));
                EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, getSelObId(event.currentTarget));
            });
    }

    protected static getSelObsWithoutVorbelegungsSelObs(selObArray:SelectableObject[]) {
        return selObArray.filter((so:SelectableObject)=>!so.isVorbelegung);
    }
}

export class LogoUebersichtListe extends EntwurfSelObListe{
    private static readonly LOGOSPERSLIDE = 8;
    private static readonly LOGOSPERSLIDE_SUB900 = 4;


    private static getLogosPerSlide() {
        return window.innerHeight < 900 ? LogoUebersichtListe.LOGOSPERSLIDE_SUB900 : LogoUebersichtListe.LOGOSPERSLIDE;
    }


    public constructor(props) {
        super(props);

    }


    private static getUebersichtEntry(imageURL, filename, id) {
        const p = HTMLPrinter;
        const idProp = LogoUebersichtListe.selobID_dataProp(id);
        const getButton = cssClasses=>p.buttonWithProps(p.cssClass(...cssClasses), idProp)("");
        return p.divWitHProps(p.cssClass("logo-box"))(
            p.divWitHProps(p.cssClass("logo-box-image checkered", LogoUebersichtListe.SHOW_SELOB_CLASS), idProp)(this.getThumbnail(imageURL, filename, id)),
            p.divWitHProps(p.cssClass("logo-box-action"))(
                getButton(["logoEdit", LogoUebersichtListe.SELECT_SELOB_CLASS]),
                getButton(["btn-delete-popup logoDelete", LogoUebersichtListe.DELETE_SELOB_CLASS])
            )
        );
    }

    private static getThumbnail = (imageURL, filename, id)=>HTMLPrinter.img(
        HTMLPrinter.cssClass("logothumbnail", LogoUebersichtListe.SHOW_SELOB_CLASS),
        HTMLPrinter.src(imageURL),
        HTMLPrinter.alt(filename),
        LogoUebersichtListe.selobID_dataProp(id)
    );

    protected getSlides(selObArray:Logo[]) {
        const logosToDisplay = LogoUebersichtListe.getSelObsWithoutVorbelegungsSelObs(owayoUtils.removeClonesFromArray(selObArray)).filter(l=>!l.isPattern) as Logo[];
        const zeilen = logosToDisplay.map((l:Logo)=>LogoUebersichtListe.getUebersichtEntry(
            l.type === SelObTypes.STOCKLOGO ? (l as StockLogo).previewPicture : l.pathToLogo,
            l.filename,
            l.id)
        );
        return LogoUebersichtListe.getSlidesHTML(zeilen, LogoUebersichtListe.getLogosPerSlide());
    }
}

export class TextUebersichtListe extends EntwurfSelObListe{
    private static readonly TEXTSPERSLIDE = 8;

    public constructor(parentSelector) {
        super(parentSelector)
    }

    protected getSlides(selObArray: any) {
        const editableTextObjectsWithoutClones = TextUebersichtListe.getSelObsWithoutVorbelegungsSelObs(owayoUtils.removeClonesFromArray(selObArray)) as TextObject[];
        const zeilen = editableTextObjectsWithoutClones.map((to: TextObject) => TextUebersichtListe.getUebersichtEntry(to.value, to.id));
        return TextUebersichtListe.getSlidesHTML(zeilen, TextUebersichtListe.TEXTSPERSLIDE);
    }

    private static getUebersichtEntry(content, id) {
        const p = HTMLPrinter;
        const textIDProp = TextUebersichtListe.selobID_dataProp(id);
        const getSpan = (cssClasses, content="")=>p.spanWithProps(p.cssClass(...cssClasses), textIDProp)(content);
        return p.divWitHProps(p.cssClass("text-wrapper"))(
            p.divWitHProps(p.cssClass("text-row"))(
                p.collection(
                    getSpan(["text-row-name", TextUebersichtListe.SHOW_SELOB_CLASS], encodeURI(content)),
                    getSpan(["text-row-edit", TextUebersichtListe.SELECT_SELOB_CLASS]),
                    getSpan(["text-row-delete", TextUebersichtListe.DELETE_SELOB_CLASS]),
                )
            )
        );
    }
}
